export default __webpack_public_path__ + "static/media/shoppi.6af64728.svg";